// extracted by mini-css-extract-plugin
export default {"wrapper":"EnergyIntervalConfig_wrapper__Wbju1","intervalCell":"EnergyIntervalConfig_intervalCell__D4hao"};